import { render, staticRenderFns } from "./spoil.vue?vue&type=template&id=8fc60f1a&scoped=true&"
import script from "./spoil.vue?vue&type=script&lang=js&"
export * from "./spoil.vue?vue&type=script&lang=js&"
import style0 from "./spoil.vue?vue&type=style&index=0&id=8fc60f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc60f1a",
  null
  
)

component.options.__file = "spoil.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
